import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/authentication/auth.guard';
import { Roles } from './Users/_models/user';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';

const router: Routes = [
   {
     path: '',
    //  loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule),
     loadChildren: './dashboard/dashboard.module#DashboardModule',
     canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
   },
  {
    path: 'access_token',
    // loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule),
    loadChildren: './dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'appPool',
    // loadChildren: () => import('./AppPool/app-pool-module').then(mod => mod.AppPoolModule),
    loadChildren: './AppPool/app-pool-module#AppPoolModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader] }
  },
  {
    path: 'dashboard',
    // loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule),
    loadChildren: './dashboard/dashboard.module#DashboardModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
  },
  {
    path: 'tenant',
    // loadChildren: () => import('./Tenant/tenant.module').then(mod => mod.TenantModule),
    loadChildren: './Tenant/tenant.module#TenantModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader] }
  }, 
  {
    path: 'topic',
    // loadChildren: () => import('./Topics/topics.module').then(mod => mod.TopicsModule),
    loadChildren: './Topics/topics.module#TopicsModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
  },
  {
    path: 'application',
    // loadChildren: () => import('./Application/application.module').then(mod => mod.ApplicationModule),
    loadChildren: './Application/application.module#ApplicationModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
  },
  {
    path: 'notification',
    // loadChildren: () => import('./notification/notification.module').then(mod => mod.NotificationModule),
    loadChildren: './notification/notification.module#NotificationModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
  },
  {
    path: 'device',
    // loadChildren: () => import('./Device/device.module').then(mod => mod.DeviceModule),
    loadChildren: './Device/device.module#DeviceModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
  },
  {
    path: 'reports',
    // loadChildren: () => import('./reports/reports.module').then(mod => mod.ReportsModule),
    loadChildren: './reports/reports.module#ReportsModule',
    canActivate: [AuthGuard], data: { roles: [Roles.SystemAdmin,Roles.SystemReader,Roles.TenantOwner,Roles.TenantReader,Roles.AppReader,Roles.AppOwner,Roles.AppNotificationOwner]}
  },
  {
    path: 'user',
    // loadChildren: () => import('./Users/users.module').then(mod => mod.UsersModule),
    loadChildren: './Users/users.module#UsersModule'
  },
  {
    path: 'api-docs',
    loadChildren: './api-docs/api-docs.module#ApiDocsModule'
  },
  {
    path: 'privacy',
    component: PrivacyComponent  
  },
  {
    path: 'terms',
    component: TermsOfUseComponent  
  }
];

export class AppRoutingModule { }

export const routes: ModuleWithProviders = RouterModule.forRoot(router, { useHash: true,enableTracing:true });
